// extracted by mini-css-extract-plugin
module.exports = {"span":"Span_span__8p3TD"};